/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
      path: '/dashboard',
      name: 'Dashboard',
      view: 'Dashboard'
    },
    {
      path: '/login',
      name: 'Login',
      view: 'Login'
    },
    {
      path: '/view-job/:id',
      name: 'JO View',
      view: 'JobView'
    },
     {
      path: '/print-view/:id',
      name: 'Print View',
      view: 'PrintView'
    },
    {
      path: '/tracker',
      name: 'Tracker',
      view: 'Tracker'
    },
    {
      path: '/users',
      name: 'User Management',
      view: 'accounts/Users'
    },
    {
      path: '/inventory',
      name: 'Inventory',
      view: 'inventory/Products'
    },
    {
      path: '/purchases',
      name: 'Purchases',
      view: 'inventory/Purchases'
    },
    {
      path: '/sales',
      name: 'Sales',
      view: 'inventory/Sales'
    },
    {
      path: '/customers',
      name: 'Customers',
      view: 'accounts/Customers'
    },
    {
      path: '/customers-mobile',
      name: 'Customers Mobile',
      view: 'accounts/CustomerMobile'
    },
    {
      path: '/vendors',
      name: 'Vendors',
      view: 'accounts/Vendors'
    },
    {
      path: '/expenses',
      name: 'Expenses',
      view: 'accounts/Expenses'
    },
    {
      path: '/general-settings',
      name: 'General Settings',
      view: 'accounts/Settings'
    },
    {
      path: '/profile',
      name: 'My Profile',
      view: 'accounts/Profile'
    },
    {
      path: '/franchisee',
      name: 'Franchisee',
      view: 'accounts/Franchisee'
    },
    {
      path: '/branch',
      name: 'Branches',
      view: 'accounts/Branch'
    },
    {
      path: '/billings',
      name: 'Billings',
      view: 'apps/Billings'
    },
    {
      path: '/my-sales',
      name: 'My Sales',
      view: 'apps/MySales'
    },
     {
      path: '/my-jobs',
      name: 'My Jobs',
      view: 'apps/MyJobs'
    },
     {
      path: '/job-board',
      name: 'Job Board',
      view: 'apps/JobBoard'
    },
    {
      path: '/wallet',
      name: 'Wallet',
      view: 'accounts/Wallet'
    },
    {
      path: '/wallet-transactions',
      name: 'Wallet Transactions',
      view: 'accounts/WalletTransactions'
    },
    {
      path: '/ledger/:id',
      name: 'Customer Ledger',
      view: 'accounts/Ledger'
    },
     {
      path: '/ledger-mobile/:id',
      name: 'Customer Ledger mobile',
      view: 'accounts/LedgerMobile'
    },
     {
      path: '/collectibles',
      name: 'Collectibles',
      view: 'accounts/CollectiblesMobile'
    },
    {
      path: '/sales-report',
      name: 'Sales Reports',
      view: 'reports/ReportSales'
    },
     {
      path: '/installments',
      name: 'Installments Reports',
      view: 'reports/Installments'
    },
     {
      path: '/cashier-reports',
      name: 'Cashier Sales',
      view: 'reports/CashierSales'
    },
    {
      path: '/profits',
      name: 'Profit and Loss Reports',
      view: 'reports/ProfitReports'
    },
      {
      path: '/expenses-reports',
      name: 'Expenses Reports',
      view: 'reports/ExpensesReports'
    },
     {
      path: '/service-personnel',
      name: 'Service Personnel Reports',
      view: 'reports/ServicePersonnel'
    },
    {
      path: '/per-outlet',
      name: 'Per Outlet',
      view: 'reports/Branch'
    },
    {
      path: '/summary',
      name: 'Collection Summary',
      view: 'reports/Summary'
    },
    {
      path: '/partners',
      name: 'Partners',
      view: 'partner/List'
    },
  ]
  